import React, { ReactElement } from 'react';

export default function ArrowForward(props: {
    className?: string;
}): ReactElement {
    const { className } = props;

    return (
        <svg className={className} fill='none' height='24' stroke='currentColor' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
            <path d='M6 7L10.2929 11.2929C10.6834 11.6834 10.6834 12.3166 10.2929 12.7071L6 17' strokeLinecap='round' />
            <path d='M12 7L16.2929 11.2929C16.6834 11.6834 16.6834 12.3166 16.2929 12.7071L12 17' strokeLinecap='round' />
        </svg>
    );
}

